// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7335":"e46afc77","7821":"ff5118bb"}[chunkId] + ".chunk.css";
};